import permissions from 'api/Apollo/permissions';
import useQuery from 'api/hooks/useQuery';

import { GET_SAMPLE_EVENT } from './sample-event-query-builder';

export default function useQuerySampleEvent(id) {
  const { data, loading, isAllowed, error, ...rest } = useQuery(GET_SAMPLE_EVENT, {
    variables: { id },
    skip: !id,
    context: { permission: permissions.readSampleEvents },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-and-network',
  });

  return { sampleEvent: data?.sampleEvent ?? null, loading, isAllowed, error, ...rest };
}
